// extracted by mini-css-extract-plugin
export default {"toggle":"LanguageToggle_toggle__uzHaY","btn":"LanguageToggle_btn__5LfsG","active":"LanguageToggle_active__iEwgd"};